import {
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import SelectErp from "../../basics/SelectErp";
import { TabTextField } from "../../documentModal/styles/DocumentModal";
import IntlCurrencyInput from "react-intl-currency-input";
import InputMask from "react-input-mask";
import MaskService from "../../../utils/mask/maskService";

const getDocumentRawValue = (value = "") =>
  value.replace(/[^\w]/gi, "").toUpperCase();

const resolveDocumentRawValue = (inputValue, previousMaskedValue = "") => {
  const rawInput = getDocumentRawValue(inputValue);
  const rawPrevious = getDocumentRawValue(previousMaskedValue);

  if (
    rawPrevious.length === 11 &&
    rawInput.length === 11 &&
    inputValue.length > previousMaskedValue.length
  ) {
    const lastChar = inputValue[inputValue.length - 1];
    if (/[\w]/i.test(lastChar)) {
      return getDocumentRawValue(`${rawPrevious}${lastChar}`);
    }
  }

  return rawInput;
};

const maskDocument = (rawValue = "") => {
  const maskType = rawValue.length <= 11 ? "cpf" : "cnpj";
  return MaskService.toMask(maskType, rawValue, "");
};

const BodyFinancialMovement = ({
  documentData,
  listCustomers,
  supplierName,
  setSupplierName,
  supplierDocument,
  setSupplierDocument,
  customerData,
  setCustomerData,
  documentType,
  disabledSupplier,
  changeDocumentData,
  ...props
}) => {
  const [description, setDescription] = useState("");
  const [competence, setCompetence] = useState("");
  const [emissionDate, setEmissionDate] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [grossAmount, setGrossAmount] = useState(0);
  const [interestAmount, setInterestAmount] = useState(0);
  const [fineAmount, setFineAmount] = useState(0);
  const [netAmount, setNetAmount] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [grossAmountExibition, setGrossAmountExibition] = useState(0);
  const [interestAmountExibition, setInterestAmountExibition] = useState(0);
  const [fineAmountExibition, setFineAmountExibition] = useState(0);
  const [discountAmountExibition, setDiscountAmountExibition] = useState(0);
  const [netAmountExibition, setNetAmountExibition] = useState(0);
  const [movementType, setMovementType] = useState("PAYABLE");

  useEffect(() => {
    const initialSetup = async () => {
      setDescription(documentData.description);
      setEmissionDate(documentData.emissionDate);
      setDueDate(documentData.dueDate);
      setCompetence(documentData.competence);
      setGrossAmount(documentData?.grossAmount || 0);
      setGrossAmountExibition(documentData?.grossAmount || 0);
      setInterestAmount(documentData?.interestAmount || 0);
      setInterestAmountExibition(documentData?.interestAmount || 0);
      setFineAmount(documentData?.fineAmount || 0);
      setFineAmountExibition(documentData?.fineAmount || 0);
      setNetAmount(documentData?.netAmount || 0);
      setNetAmountExibition(documentData?.netAmount || 0);
      setDiscountAmount(documentData?.discountAmount || 0);
      setDiscountAmountExibition(documentData?.discountAmount || 0);

      setMovementType(documentData.movementType);
    };
    initialSetup();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (documentData.movementType !== movementType) {
      setMovementType(documentData.movementType);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentData?.movementType]);

  const onChangeData = (changedProperties) => {
    let newDocumentData = {
      ...documentData,
      description: description,
      emissionDate: emissionDate,
      dueDate: dueDate,
      competence: competence,
      grossAmount: grossAmount,
      interestAmount: interestAmount,
      fineAmount: fineAmount,
      netAmount: netAmount,
      movementType: movementType,
      supplierName: supplierName,
      supplierDocument: supplierDocument,
      customerData: customerData,
      discountAmount: discountAmount,
    };

    newDocumentData = {
      ...newDocumentData,
      ...changedProperties,
    };

    changeDocumentData(newDocumentData);
  };

  return (
    <>
      <Grid item xs={12}>
        <TabTextField
          label="Descrição"
          variant="outlined"
          value={description}
          onChange={(ev) => {
            setDescription(ev.target.value);
            onChangeData({ description: ev.target.value });
          }}
        />
      </Grid>
      <Grid item xs={4}>
        <InputMask
          mask="99/99/9999"
          disabled={false}
          maskChar=""
          value={emissionDate}
          onChange={(ev) => {
            setEmissionDate(ev.target.value);
            onChangeData({ emissionDate: ev.target.value });
          }}
        >
          {() => <TabTextField label="Data de Emissão" variant="outlined" />}
        </InputMask>
      </Grid>
      <Grid item xs={4}>
        <InputMask
          mask="99/99/9999"
          disabled={false}
          maskChar=""
          value={dueDate}
          onChange={(ev) => {
            setDueDate(ev.target.value);
            onChangeData({ dueDate: ev.target.value });
          }}
        >
          {() => <TabTextField label="Data de Vencimento" variant="outlined" />}
        </InputMask>
      </Grid>

      <Grid item xs={4}>
        <InputMask
          mask="99/9999"
          disabled={false}
          maskChar=""
          value={competence}
          onChange={(ev) => {
            setCompetence(ev.target.value);
            onChangeData({ competence: ev.target.value });
          }}
        >
          {() => <TabTextField label="Competência" variant="outlined" />}
        </InputMask>
      </Grid>

      <Grid item xs={4}>
        <div
          class="MuiFormControl-root MuiTextField-root "
          style={{
            marginBottom: 5,
            width: "100%",
            border: "1px solid #b7b5b5",
            borderRadius: "5px",
            position: "relative",
            paddingTop: 8,
            height: 37,
          }}
        >
          <label
            style={{ background: "#f2f2f2" }}
            class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-marginDense MuiInputLabel-outlined MuiFormLabel-filled"
            data-shrink="true"
          >
            Valor Bruto
          </label>

          <div class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-formControl MuiInputBase-marginDense MuiOutlinedInput-marginDense">
            <IntlCurrencyInput
              currency="BRL"
              value={grossAmountExibition}
              class="MuiInputBase-input MuiOutlinedInput-input MuiInputBase-inputMarginDense MuiOutlinedInput-inputMarginDense"
              config={{
                locale: "pt-BR",
                formats: {
                  number: {
                    BRL: {
                      style: "currency",
                      currency: "BRL",
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    },
                  },
                },
              }}
              onChange={(event, value, maskedValue) => {
                event.preventDefault();
                setGrossAmount(value);
                setGrossAmountExibition(maskedValue);

                const newNetAmount =
                  value + interestAmount + fineAmount - discountAmount;
                setNetAmount(newNetAmount);
                setNetAmountExibition(newNetAmount);

                onChangeData({
                  grossAmount: value,
                  netAmount: newNetAmount,
                });
              }}
            />
          </div>
        </div>
      </Grid>

      <Grid item xs={4}>
        <div
          class="MuiFormControl-root MuiTextField-root "
          style={{
            marginBottom: 5,
            width: "100%",
            border: "1px solid #b7b5b5",
            borderRadius: "5px",
            position: "relative",
            paddingTop: 8,
            height: 37,
          }}
        >
          <label
            style={{ background: "#f2f2f2" }}
            class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-marginDense MuiInputLabel-outlined MuiFormLabel-filled"
            data-shrink="true"
          >
            Juros
          </label>

          <div class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-formControl MuiInputBase-marginDense MuiOutlinedInput-marginDense">
            <IntlCurrencyInput
              currency="BRL"
              value={interestAmountExibition}
              class="MuiInputBase-input MuiOutlinedInput-input MuiInputBase-inputMarginDense MuiOutlinedInput-inputMarginDense"
              config={{
                locale: "pt-BR",
                formats: {
                  number: {
                    BRL: {
                      style: "currency",
                      currency: "BRL",
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    },
                  },
                },
              }}
              onChange={(event, value, maskedValue) => {
                event.preventDefault();
                setInterestAmount(value);
                setInterestAmountExibition(maskedValue);
                const newNetAmount =
                  grossAmount + value + fineAmount - discountAmount;
                setNetAmount(newNetAmount);
                setNetAmountExibition(newNetAmount);
                onChangeData({
                  interestAmount: value,
                  netAmount: newNetAmount,
                });
              }}
            />
          </div>
        </div>
      </Grid>

      <Grid item xs={4}>
        <div
          class="MuiFormControl-root MuiTextField-root "
          style={{
            marginBottom: 5,
            width: "100%",
            border: "1px solid #b7b5b5",
            borderRadius: "5px",
            position: "relative",
            paddingTop: 8,
            height: 37,
          }}
        >
          <label
            style={{ background: "#f2f2f2" }}
            class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-marginDense MuiInputLabel-outlined MuiFormLabel-filled"
            data-shrink="true"
          >
            Multa
          </label>
          <div class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-formControl MuiInputBase-marginDense MuiOutlinedInput-marginDense">
            <IntlCurrencyInput
              currency="BRL"
              value={fineAmountExibition}
              class="MuiInputBase-input MuiOutlinedInput-input MuiInputBase-inputMarginDense MuiOutlinedInput-inputMarginDense"
              config={{
                locale: "pt-BR",
                formats: {
                  number: {
                    BRL: {
                      style: "currency",
                      currency: "BRL",
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    },
                  },
                },
              }}
              onChange={(event, value, maskedValue) => {
                event.preventDefault();
                setFineAmount(value);
                setFineAmountExibition(maskedValue);
                const newNetAmount =
                  grossAmount + interestAmount + value - discountAmount;
                setNetAmount(newNetAmount);
                setNetAmountExibition(newNetAmount);
                onChangeData({
                  fineAmount: value,
                  netAmount: newNetAmount,
                });
              }}
            />
          </div>
        </div>
      </Grid>

      <Grid item xs={4}>
        <div
          class="MuiFormControl-root MuiTextField-root "
          style={{
            marginBottom: 5,
            width: "100%",
            border: "1px solid #b7b5b5",
            borderRadius: "5px",
            position: "relative",
            paddingTop: 8,
            height: 37,
          }}
        >
          <label
            style={{ background: "#f2f2f2" }}
            class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-marginDense MuiInputLabel-outlined MuiFormLabel-filled"
            data-shrink="true"
          >
            Desconto
          </label>

          <div class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-formControl MuiInputBase-marginDense MuiOutlinedInput-marginDense">
            <IntlCurrencyInput
              currency="BRL"
              value={discountAmountExibition}
              class="MuiInputBase-input MuiOutlinedInput-input MuiInputBase-inputMarginDense MuiOutlinedInput-inputMarginDense"
              config={{
                locale: "pt-BR",
                formats: {
                  number: {
                    BRL: {
                      style: "currency",
                      currency: "BRL",
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    },
                  },
                },
              }}
              onChange={(event, value, maskedValue) => {
                event.preventDefault();
                setDiscountAmount(value);
                setDiscountAmountExibition(maskedValue);
                const newNetAmount =
                  grossAmount + interestAmount + fineAmount - value;
                setNetAmount(newNetAmount);
                setNetAmountExibition(newNetAmount);
                onChangeData({
                  discountAmount: value,
                  netAmount: newNetAmount,
                });
              }}
            />
          </div>
        </div>
      </Grid>

      <Grid item xs={4}>
        <div
          class="MuiFormControl-root MuiTextField-root "
          style={{
            marginBottom: 5,
            width: "100%",
            border: "1px solid #b7b5b5",
            borderRadius: "5px",
            position: "relative",
            paddingTop: 8,
            height: 37,
          }}
        >
          <label
            style={{ background: "#f2f2f2" }}
            class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-marginDense MuiInputLabel-outlined MuiFormLabel-filled"
            data-shrink="true"
          >
            Valor Total
          </label>
          <div class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-formControl MuiInputBase-marginDense MuiOutlinedInput-marginDense">
            <IntlCurrencyInput
              currency="BRL"
              value={netAmountExibition}
              class="MuiInputBase-input MuiOutlinedInput-input MuiInputBase-inputMarginDense MuiOutlinedInput-inputMarginDense"
              config={{
                locale: "pt-BR",
                formats: {
                  number: {
                    BRL: {
                      style: "currency",
                      currency: "BRL",
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    },
                  },
                },
              }}
              onChange={(event, value, maskedValue) => {
                event.preventDefault();
                setNetAmount(value);
                setNetAmountExibition(maskedValue);
                onChangeData({ netAmount: value });
              }}
            />
          </div>
        </div>
      </Grid>
      {!disabledSupplier && (
        <Grid item xs={12}>
          <FormControl component="fieldset" style={{ width: "100%" }}>
            <RadioGroup
              color="primary"
              value={movementType}
              name="radio-buttons-group"
              row
            >
              <Grid container>
                <Grid
                  item
                  xs={6}
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    paddingLeft: 8,
                  }}
                >
                  <FormControlLabel
                    value="PAYABLE"
                    control={<Radio color="primary" />}
                    onClick={(e) => {
                      setMovementType(e.target.value);
                      onChangeData({ movementType: e.target.value });
                    }}
                    label="Pagamento"
                  />
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    paddingLeft: 8,
                  }}
                >
                  <FormControlLabel
                    value="RECEIVABLE"
                    control={<Radio color="primary" />}
                    onClick={(e) => {
                      setMovementType(e.target.value);
                      onChangeData({ movementType: e.target.value });
                    }}
                    label="Recebimento"
                  />
                </Grid>
              </Grid>
            </RadioGroup>
          </FormControl>
        </Grid>
      )}

      {movementType === "PAYABLE" && !disabledSupplier && (
        <>
          <Grid item xs={6}>
            <TabTextField
              label="CPF/CNPJ Fornecedor"
              variant="outlined"
              value={supplierDocument}
              disable={disabledSupplier}
              onChange={(e) => {
                const rawDocument = resolveDocumentRawValue(
                  e.target.value,
                  supplierDocument
                );
                const maskedDocument = maskDocument(rawDocument);

                setSupplierDocument(maskedDocument);
                onChangeData({
                  supplierDocument: maskedDocument,
                  relatedEntity: {
                    document: rawDocument,
                    name: supplierName,
                  },
                });
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <TabTextField
              label="Nome Fornecedor"
              variant="outlined"
              value={supplierName}
              disable={disabledSupplier}
              onChange={(ev) => {
                setSupplierName(ev.target.value);
                onChangeData({
                  supplierName: ev.target.value,
                  relatedEntity: {
                    name: ev.target.value,
                    document: getDocumentRawValue(supplierDocument),
                  },
                });
              }}
            />
          </Grid>
        </>
      )}

      {movementType === "RECEIVABLE" && !disabledSupplier && (
        <Grid item xs={12}>
          <SelectErp
            variant="outlined"
            label="Cliente"
            size="medium"
            value={customerData}
            setValue={setCustomerData}
            optionsList={listCustomers}
            descriptionField="company_name"
            getOptionLabel={(option) => {
              let maskedDocument = "";
              if (getDocumentRawValue(option.document).length > 11) {
                maskedDocument = MaskService.toMask("cnpj", option.document);
              } else {
                maskedDocument = MaskService.toMask("cpf", option.document);
              }

              return `${option.company_name} - ${maskedDocument}`;
            }}
          />
        </Grid>
      )}
    </>
  );
};

export default BodyFinancialMovement;
